import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.ts";
import { TaskCache } from "../server/objects/TaskBeans.ts";

export {initDom,destroyDom}
Html.registerWidget('widget/minilist',{initDom:initDom,destroyDom:destroyDom})

var node: HTMLElement;
async function display(){
  const TPL = await import("../widget/minilist.mustache");
  var cloned = [].concat(TaskCache.datas);
  cloned.sort(function(a,b){
    if(a.complete!==b.complete){
      return a.complete?1:-1;
    }
    return b.creationDate-a.creationDate;
  })
  Html.setHtml(node,TPL,{feed:cloned.slice(0,3)});
}

function initDom(container: HTMLElement){
  node = container;
  if(container.offsetParent !== null) { // Vérifie si l'élément est visible
    ApiServer.loadTaskAndList();
    amplify.subscribe("taskRefreshed",display);
  }
}
function destroyDom(){
  amplify.unsubscribe("taskRefreshed",display);
}
